// Solo una respuesta con status "ok" y sin errores cuenta como restauración completa.
export function esRestauracionCompleta(data) {
  return !!data && data.status === "ok" && !(Array.isArray(data.errors) && data.errors.length > 0);
}
